<template>
	<div class="accommodation-area">
		<!-- Area info -->
		<div class="accommodation-area__container grid-x grid-margin-x">
			<div class="cell small-12 medium-5">
				<img
					class="accommodation-area__image"
					:height="imageHeight"
					:width="imageWidth"
					:src="getImgUrl(image, 'array')"
					:alt="title"
				/>
			</div>

			<div class="cell small-12 medium-7">
				<div class="accommodation-area__head">
					<span class="accommodation-area__label">
						{{ $t('search.areaAccordionSubtitle') }}
					</span>
					<span class="accommodation-area__title">
						{{ toLowerCase(title) }}
					</span>
				</div>
				<div class="accommodation-area__text" v-if="description">
					{{ description }}
				</div>
				<ul class="accommodation-area__facilities">
					<li v-for="facility in facilities" :key="title + facility">
						<svg width="13" height="12" viewBox="0 0 13 12" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" v-bind:svg-inline="''" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><defs><path d="M5.429 11a1 1 0 01-.76-.348l-3.427-4A1 1 0 112.759 5.35l2.506 2.923 3.867-6.768a.997.997 0 011.364-.372c.48.274.647.885.372 1.364l-4.571 8a1.002 1.002 0 01-.868.504" id="a"/></defs><g transform="translate(.8)" fill="none" fill-rule="evenodd"><mask id="b" fill="#fff"><use xlink:href="#a"/></mask><use fill="#000" xlink:href="#a"/><g mask="url(#b)" fill="#7F8BA1"><path d="M0 0h12v12H0z"/></g></g></svg>
						<span>{{ facility }}</span>
					</li>
				</ul>
			</div>
		</div>

		<!-- Accommodation list -->
		<Accordion
			v-on:toggle="
				() => {
					this.accordionShow = !this.accordionShow
				}
			"
			:title="
				$t('search.showAll') +
				' ' +
				this.amountOfResults +
				' ' +
				$t('search.accommodations')
			"
			v-bind:show="this.accordionShow"
			:lightTheme="true"
			:blueTheme="true"
			:largeSvg="true"
			:showFooter="true"
		>
			<slot></slot>
		</Accordion>
	</div>
</template>

<script>
import mixin from '../../mixin'
import Accordion from '../molecules/Accordion.vue'

export default {
	name: 'AccommodationArea',
	mixins: [mixin],
	components: {
		Accordion
	},
	props: {
		id: {
			type: Number,
			default: 0
		},
		image: {
			type: Array,
			default: () => []
		},
		imageWidth: {
			type: Number,
			default: 360
		},
		imageHeight: {
			type: Number,
			default: 220
		},
		placeholderImage: {
			type: String,
			default: 'https://boka.klappen.se/images/klappen_boende_fallback.jpg'
		},
		title: {
			type: String,
			default: ''
		},
		description: {
			type: String,
			default: ''
		},
		facilities: {
			type: Array,
			default: () => []
		},
		amountOfResults: {
			type: Number,
			default: 0
		}
	},
	data() {
		return {
			accordionShow: false
		}
	},
	methods: {},
	computed: {}
}
</script>

<style scoped lang="scss">
.accommodation-area {
	padding: 0;
	background: #f4f5f7;
	align-items: top;
	margin-bottom: 50px;

	&__container {
		box-sizing: border-box;
		padding: 20px;
		align-self: flex-start;

		@include for-tablet-portrait-up {
			padding: 40px;
		}
	}

	&__image {
		width: 100%;
		background-size: cover;
		background-repeat: no-repeat;
		box-sizing: border-box;
		padding: 10px;
		object-fit: cover;
		padding: 0;
		margin-bottom: 15px;
		// height: 200px;

		img {
			width: 100%;
			visibility: hidden;
		}

		@include for-tablet-landscape-up {
			margin-bottom: 0;
		}
	}

	&__head {
		// display: flex;
		// justify-content: space-between;
	}

	&__label {
		display: block;
		color: $colorPrimary;
		font-family: Saira;
		font-size: 11px;
		font-weight: 500;
		text-transform: uppercase;
		margin-bottom: 10px;
	}

	&__title {
		display: block;
		color: $colorGrey8;
		font-family: Saira;
		font-size: 28px;
		font-weight: 300;
		line-height: 32px;
		text-transform: capitalize;
		margin-bottom: 10px;
	}

	&__text {
		color: $colorGrey8;
		font-family: Saira;
		font-size: 14px;
		line-height: 24px;
		padding-bottom: 15px;
		margin-bottom: 10px;
	}

	&__facilities {
		font-family: Saira;
		font-size: 14px;
		line-height: 24px;

		li {
			padding-right: 20px;
			padding-bottom: 10px;

			svg {
				margin-right: 8px;
				margin-top: 3px;
				display: inline-block;
				width: 10px;
				height: 10px;
			}
		}

		@include for-tablet-landscape-up {
			columns: 2;
			-webkit-columns: 2;
			-moz-columns: 2;
		}
	}
}
</style>
